module.exports = __webpack_public_path__ + "static/media/N_animation.e59fadd8.mp4";